export default ({axios, mapQueryString, withoutInvalidValues}) => ({
    list: (query = {}) => axios.get(`/collaborations${mapQueryString(withoutInvalidValues(query))}`),
    show: (id, query = {}) => axios.get(`/collaborations/${id}${mapQueryString(query)}`),
    update: (id, body) => axios.patch(`/collaborations/${id}`, withoutInvalidValues(body)),
    collabFoodie: (collabId, foodieId, query = {}) => axios.get(`/collaborations/${collabId}/foodies/${foodieId}${mapQueryString(query)}`),
    activateCollab: (collabId, body = {}) => axios.patch(`/collaborations/${collabId}/set-active`, body),
})
